"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var stimulus_1 = require("stimulus");
var validator_1 = __importDefault(require("~/validator/validator"));
var INVALID_MESSAGE = '無効な値が入力されています';
var TelephoneValidatableController = /** @class */ (function (_super) {
    __extends(TelephoneValidatableController, _super);
    function TelephoneValidatableController() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.validate = function () {
            var _a;
            (_a = _this.telephoneInputTargets) === null || _a === void 0 ? void 0 : _a.forEach(function (elt) { return elt.setCustomValidity(''); });
            var invalidElements = _this.telephoneInputTargets
                ? _this.telephoneInputTargets.filter(function (target) { return !validator_1.default.validateTel(target.value); })
                : [];
            invalidElements.forEach(function (elt) { return elt.setCustomValidity(INVALID_MESSAGE); });
            return invalidElements.length === 0;
        };
        return _this;
    }
    TelephoneValidatableController.targets = ['telephoneInput'];
    return TelephoneValidatableController;
}(stimulus_1.Controller));
exports.default = TelephoneValidatableController;
